/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-11-09 15:47:49
 * @LastEditors: WangYuhan
 */
export const tabbar = [
  {
    label: '待支付',
    value: 'PAYING',
    status: 'payingNum',
  },
  {
    label: '已拒绝',
    value: 'REFUSE',
    status: 'refuseNum',
  },
  {
    label: '支付中',
    value: 'LINE_PAYING',
    status: 'linePayingNum',
  },

  {
    label: '已完成',
    value: 'SUCCESS',
    status: 'finishNum',
  },
  {
    label: '月账单',
    value: 'DUIZHANG',
    status: 'duizhang',
  },
];

export const tabbarReal = [
  {
    label: '待支付',
    value: 'PAYING',
    status: 'payingNum',
  },
  {
    label: '已拒绝',
    value: 'REFUSE',
    status: 'refuseNum',
  },
  {
    label: '支付中',
    value: 'LINE_PAYING',
    status: 'linePayingNum',
  },
  {
    label: '已完成',
    value: 'SUCCESS',
    status: 'finishNum',
  },
];

export const tabbarOil = [
  {
    label: '待支付',
    value: 'PAYING',
    status: 'payingNum',
  },
  {
    label: '已拒绝',
    value: 'REFUSE',
    status: 'refuseNum',
  },
  {
    label: '已完成',
    value: 'SUCCESS',
    status: 'finish',
  },
  {
    label: '月账单',
    value: 'DUIZHANG',
    status: 'duizhang',
  },
];

export const tabbarnetFan = [
  {
    label: '待开票',
    value: 'PAYING',
    status: 'payingNum',
  },
  {
    label: '已申请',
    value: 'LINE_PAYING',
    status: 'linePayingNum',
  },
  {
    label: '开票中',
    value: 'REFUSE',
    status: 'refuseNum',
  },
  {
    label: '已开票',
    value: 'SUCCESS',
    status: 'finishNum',
  },
];

export const tabbarOilFan = [
  {
    label: '开票记录',
    value: 'PAYING',
    status: 'payingNum',
  },
];

export const cargo = [
  { value: '装货量', label: '装货量' },
  { value: '卸货量', label: '卸货量' },
  { value: '较小值', label: '较小值' },
];

export const payTypes = [
  { value: 1, label: '结算给司机' },
  { value: 2, label: '自定义' },
];

export const other = [
  { value: '保险', label: '保险' },
  { value: '装车费', label: '装车费' },
  { value: '其他', label: '其他' },
];
// 运单用油
export const orderUseoil = [
  { label: '全部', value: '' },
  { label: '未完成消费', value: '1' },
  { label: '已完成消费', value: '2' },
];

export const oilType = [
  { value: 0, label: '%' },
  { value: 1, label: '元' },
];

// 交易类型
export const transTypes = [
  { label: '全部', value: '' },
  { label: '储值', value: 'app_financial_deposit' },
  { label: '外协车消费', value: 'app_etcwx' },
  { label: '自有车消费', value: 'app_etczy' },
  { label: '退款', value: 'rush_out' },
];

// 交易类型
export const transactionNetGoodsTypes = [
  { label: '储值', value: 'RECHARGE' },
  { label: '油气充值', value: 'OILRECHARGE' },
  { label: 'ETC充值', value: 'ETCRECHARGE' },
  { label: '网货交易', value: 'NETFREIGHT' },
];

// 收支类型
export const consumerTypes = [
  { label: '全部', value: '' },
  { label: '支出', value: 'xf' },
  { label: '收入', value: 'cz' },
];

// 收支类型
export const waybillSources = [
  { label: '全部', value: '' },
  { label: '网货业务', value: 'ONESTOP' },
  { label: 'EXCEL上传', value: 'EXCEL' },
  { label: 'API', value: 'OPENAPI' },
];

// 结算方式
export const payTypeList = [
  { label: '司机', value: '1' },
  { label: '经纪人', value: '2' },
];

// 定价方式
export const priceTypeList = [
  { label: '协商定价', value: '1' },
  { label: '按货量定价', value: '2' },
];

// 是/否
export const whethers = [
  { label: '是', value: 1 },
  { label: '否', value: 0 },
];

// 结算单类型
export const waybillPayStatus = [
  { label: '待支付', value: 1 },
  { label: '部分支付', value: 2 },
  { label: '已支付', value: 3 },
];

// 结算单类型
export const settlementTypes = [
  { label: '预付运费', value: 'PAYADVANCE' },
  { label: '到付运费', value: 'PAYARRIVE' },
  { label: '回单押金', value: 'PAYBACK' },
];

// 网络货运平台列表
export const channelInfos = [
  { label: '湖北我家物流服务有限公司', value: 'hubeiwojia' },
  { label: '安徽我家物流服务有限公司', value: 'anhuiwojia' },
  { label: '安徽省徽商登峰物流科技有限公司', value: 'dengfenghuishang' },
  { label: '湖北赢路物流有限公司安陆分公司', value: 'anluwojia' },
  { label: '淮安市翔和翎物流有限公司', value: 'xiangheling' },
  { label: '安徽省徽商登峰物流科技有限公司芜湖市分公司', value: 'wuhuhuishang' },
  { label: '华米互联网科技（济南）有限公司青岛分公司', value: 'huami' },
  { label: '安徽省徽商物流有限公司', value: 'huishang' },
];

// 网货 运单来源
export const waybillNetSources = [
  { label: '牛运宝开单', value: 'WEB' },
  { label: '牛运宝导表', value: 'EXCEL' },
  { label: '小跟班', value: 'XGB' },
  { label: '小跟班-调度', value: 'WX_DISPATCH' },
  { label: '小跟班-司机', value: 'WX_DRIVER' },
  { label: '录单工具', value: 'WEB_CRAWLER' },
  { label: '便捷录单-顺丰', value: 'WEB_CRAWLER_SF' },
  { label: '便捷录单-京东', value: 'WEB_CRAWLER_JD' },
  { label: '便捷录单-申通', value: 'WEB_CRAWLER_ST' },
  { label: '便捷录单-圆通', value: 'WEB_CRAWLER_YT' },
  { label: '便捷录单-顺丰快达', value: 'WEB_CRAWLER_SFKD' },
  { label: '便捷录单-百世快递', value: 'WEB_CRAWLER_BSKD' },
  { label: '便捷录单-百世快运', value: 'WEB_CRAWLER_BSKY' },
];

// 是/否
export const oneTicket = [
  { label: '是', value: 'ON' },
  { label: '否', value: 'OFF' },
];

export const oneTicketList = [
  { label: '非一张票', value: 'noOneTicketCode' },
  { label: '一张票（徽商登峰）', value: 'chengfengwangluo-ceshi' },
];
